import type {
    VirtualAppointmentDto,
    VirtualAppointmentTeam
} from '../../../../services/virtualAppointments';
import { VaHandoffConfirmModal } from './VaHandoffConfirmModal';
import { VaHandoffReasonModal } from './VaHandoffReasonModal';
import type { VaHandoff, VaHandoffKind, VaReasonHandoffKind } from './useVaHandoff';

// The team whose open VAs the backend moves along with the case.
const LEFT_TEAM: Record<VaReasonHandoffKind, VirtualAppointmentTeam> = {
    'escalate-to-clinical': 'DM',
    'hand-back-to-dm': 'Clinical'
};

interface VaHandoffDialogProps {
    kind: VaHandoffKind;
    runner: VaHandoff;
    open: readonly VirtualAppointmentDto[];
    onClose: () => void;
}

// Switching teams needs the author's text; continuing treatment is a plain confirm.
export function VaHandoffDialog({ kind, runner, open, onClose }: VaHandoffDialogProps) {
    if (kind === 'continue-treatment') {
        return (
            <VaHandoffConfirmModal
                kind={kind}
                submitting={runner.submitting}
                error={runner.error}
                onConfirm={() => void runner.run({ kind })}
                onClose={onClose}
            />
        );
    }
    return (
        <VaHandoffReasonModal
            kind={kind}
            movedCount={open.filter((va) => va.team === LEFT_TEAM[kind]).length}
            submitting={runner.submitting}
            error={runner.error}
            onConfirm={(reason) => void runner.run({ kind, reason })}
            onClose={onClose}
        />
    );
}
